import { ElementController } from 'js-common';

import { TAG_FILTER_CONTROLLER_ID } from './constants';

const ACTIVE_TAG_CLASS = 'tag--active';

export default class TagFilteredContent extends ElementController {
  static id = TAG_FILTER_CONTROLLER_ID;

  init() {
    this.filterButtons = this.selectAll('[data-tag]');
    this.filterItems = this.selectAll('filterable-item');

    this.on(this.filterButtons, 'click', this.filterByTag);
    this.showAll();
  }

  showAll() {
    this.filterItems.forEach((item) => {
      item.classList.remove('hidden');
    });
    this.filterButtons.forEach((button) => {
      if (button.dataset.tag === 'all') {
        button.classList.add(ACTIVE_TAG_CLASS);
      } else {
        button.classList.remove(ACTIVE_TAG_CLASS);
      }
    });
  }

  filterByTag = (e) => {
    const { tag } = e.currentTarget.dataset;

    if (tag === 'all') {
      this.showAll();
      return;
    }

    this.filterItems.forEach((item) => {
      const itemTags = item.dataset.tags.split(',').map((t) => t.trim());
      if (itemTags.includes(tag)) {
        item.classList.remove('hidden');
      } else {
        item.classList.add('hidden');
      }
    });

    this.filterButtons.forEach((button) => {
      if (button.dataset.tag === tag) {
        button.classList.add(ACTIVE_TAG_CLASS);
      } else {
        button.classList.remove(ACTIVE_TAG_CLASS);
      }
    });
  };
}
